import { auth } from './metas'
import RouteDelegate from './RouteDelegate'
const Expert = () => import('@/pages/Expert')
const Team = () => import('@/pages/Team')

export default [
  {
    path: '/experts',
    component: RouteDelegate,
    meta: auth,
    children: [
      {
        path: '/',
        name: 'Team',
        component: Team
      },
      {
        path: ':id/:tab',
        name: 'Expert',
        component: Expert,
        props: route => ({
          id: parseInt(route.params.id, 10),
          tab: route.params.tab || 'profile'
        })
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/experts.route.js